import Hero from "./components/Hero/Hero";
import Navbarr from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";

function App() {
  return (
    <div className="App">
      <Navbarr />
      <Hero />
      <Footer />
    </div>
  );
}

export default App;
